export function isLicensePlate(licensePlate) {
  const regex = /(\w{3})-(\d\w\d\d)/;
  return (licensePlate.match(regex))
}
